"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.DropDownComponent = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _native = _interopRequireDefault(require("styled-components/native"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _forms = require("@morpheus-ui/forms");

var _reactOverlays = require("react-overlays");

var _zIndexClass = _interopRequireDefault(require("../zIndexClass"));

var _getElementPosition = _interopRequireDefault(require("../getElementPosition"));

var _ThemeProvider = _interopRequireWildcard(require("./ThemeProvider"));

function _templateObject12() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  padding: ", ";\n  color: ", ";\n  font-size: ", ";\n  border-bottom-width: ", ";\n  border-bottom-color: ", ";\n  border-bottom-style: solid;\n\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  outline: none;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background-color: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  position: absolute;\n  width: ", "px;\n  left: ", "px;\n  top: ", "px;\n  ", ";\n\n  max-height: ", ";\n\n  border-width: ", ";\n  border-color: ", ";\n  border-style: solid;\n  border-radius: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n  padding: 2px 0;\n  margin-bottom: 2px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  display: flex;\n  margin-left: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  color: ", ";\n\n  ", "\n\n  ", "\n \n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  z-index: 1;\n  min-width: ", ";\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: row;\n  align-items: center;\n  border-width: ", ";\n  border-color: ", ";\n  border-style: solid;\n  border-radius: ", ";\n  padding: ", ";\n  background-color: ", ";\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex-direction: column;\n  position: relative;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  margin: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BACKSTYLE = {
  position: 'fixed',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  overflow: 'auto'
};

var SvgArrowDown = function SvgArrowDown(props) {
  return _react.default.createElement("svg", (0, _extends2.default)({
    width: "8",
    height: "5",
    viewBox: "0 0 8 5"
  }, props), _react.default.createElement("path", {
    d: "M7.146.146L4 3.293.853.146a.5.5 0 0 0-.707.708l3.5 3.5a.498.498 0 0 0 .708 0l3.5-3.5a.5.5 0 0 0-.708-.708z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

var OutterContainer = _native.default.View(_templateObject(), function (props) {
  return props.muitheme.margin;
});

var Container = _native.default.View(_templateObject2());

var Touchable = _native.default.TouchableOpacity(_templateObject3(), function (props) {
  return props.isopen && " outline: none;";
});

var InnerContainer = _native.default.View(_templateObject4(), function (props) {
  return props.muitheme.minWidth;
}, function (props) {
  return props.muitheme.borderWidth;
}, function (props) {
  return props.muitheme.borderColor;
}, function (props) {
  return props.muitheme.borderRadius;
}, function (props) {
  return props.muitheme.padding;
}, function (props) {
  return props.muitheme.backgroundColor;
}, function (props) {
  return props.disabled && "border-color: " + props.muitheme.borderDisabledColor + ";\n     background-color: " + props.muitheme.backgroundDisabledColor + ";";
});

var Label = _native.default.Text(_templateObject5(), function (props) {
  return props.muitheme.fontFamily;
}, function (props) {
  return props.muitheme.fontSize;
}, function (props) {
  return props.muitheme.fontWeight;
}, function (props) {
  return props.muitheme.fontStyle;
}, function (props) {
  return props.muitheme.labelColor;
}, function (props) {
  return props.value && "color: " + props.labelCheckedColor + ";";
}, function (props) {
  return props.disabled && "color: " + props.muitheme.labelDisabledColor + ";";
});

var IconContainer = _native.default.Text(_templateObject6(), function (props) {
  return props.muitheme.arrowColor;
}, function (props) {
  return props.muitheme.arrowMargin;
});

var ErrorMessage = _native.default.Text(_templateObject7(), function (props) {
  return props.muitheme.fontFamily;
}, function (props) {
  return props.muitheme.errorFontSize;
}, function (props) {
  return props.muitheme.errorColor;
});

var DropMenu = _native.default.View(_templateObject8(), function (props) {
  return props.muitheme.menuBackgroundColor;
}, function (props) {
  return props.width;
}, function (props) {
  return props.position.x;
}, function (props) {
  return props.position.y - 1;
}, function (props) {
  return props.muitheme.menuShadow && "\n    shadow-color: #000;\n    shadow-offset: {width: 0, height: 0};\n    shadow-opacity: 0.1;\n    shadow-radius: 8;\n  ";
}, function (props) {
  return props.muitheme.menuMaxHeight;
}, function (props) {
  return props.muitheme.menuBorderWidth;
}, function (props) {
  return props.muitheme.menuBorderColor;
}, function (props) {
  return props.muitheme.menuBorderRadius;
});

var Backdrop = _native.default.TouchableOpacity(_templateObject9(), function (props) {
  return props.muitheme.menuBackdropColor;
});

var ScrollView = _native.default.ScrollView(_templateObject10());

var DropItem = _native.default.TouchableOpacity(_templateObject11());

var ItemText = _native.default.Text(_templateObject12(), function (props) {
  return props.muitheme.menuItemBackgroundColor;
}, function (props) {
  return props.muitheme.menuItemPadding;
}, function (props) {
  return props.muitheme.menuItemTextColor;
}, function (props) {
  return props.muitheme.menuItemFontSize;
}, function (props) {
  return props.muitheme.menuItemSeparatorWidth;
}, function (props) {
  return props.muitheme.menuItemSeparatorColor;
}, function (props) {
  return props.selected && "background-color: " + props.muitheme.menuItemSelectedBackgroundColor + ";";
}, function (props) {
  return props.withfocus === 'true' && "background-color: " + props.muitheme.menuItemFocusBackgroundColor + ";\n     color: " + props.muitheme.menuItemFocusTextColor + ";";
}, function (props) {
  return props.selected && "color: " + props.muitheme.menuItemSelectedTextColor + ";";
});

var DropDownComponent =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(DropDownComponent, _Component);

  // $FlowFixMe: React Ref
  function DropDownComponent(_props) {
    var _this;

    _this = _Component.call(this, _props) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "containerRef", (0, _react.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getPosition", function () {
      _this.setState({
        containerPos: (0, _getElementPosition.default)(_this.containerRef.current),
        containerWidth: _this.containerRef.current ? // $FlowFixMe: OffSet
        _this.containerRef.current.offsetWidth : null
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getDropDownTheme", (0, _memoizeOne.default)(function (props, context) {
      return (0, _ThemeProvider.getTheme)('DropDown', props, context);
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onPress", function () {
      if (_this.state.open) {
        _this.closeMenu();
      } else {
        _this.openMenu();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "openMenu", function () {
      if (!_this.props.disabled) {
        _this.setState({
          open: true
        });

        !_this.props.dirty && _this.props.setDirty && _this.props.setDirty();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "closeMenu", function () {
      if (_this.state.focus > -1) {
        var item = _this.props.options[_this.state.focus];

        if (typeof item === 'string') {
          _this.selectItem(item);
        } else {
          _this.selectItem(item[_this.props.valueKey]);
        }
      }

      _this.dismissMenu();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "dismissMenu", function () {
      _this.setState({
        open: false,
        focus: -1
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleInputKeyDown", function (e) {
      var key = e.which || e.keyCode;

      if (_this.state.open) {
        if (key === 27) {
          // ESCAPE
          _this.dismissMenu();
        }

        if (key === 38) {
          // Arrow UP
          _this.moveFocus(-1);
        }

        if (key === 40) {
          // Arrow Down
          _this.moveFocus(1);
        }
      } else {
        if (key === 38 || key === 40) {
          // Arrow UP or Down
          _this.openMenu();
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "printValue", function (value) {
      var item = _this.getItemFromValue(value);

      return _this.printItem(item);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "printItem", function (item) {
      if (typeof item === 'string') {
        return item;
      }

      if (!_this.props.displayKey) {
        return item[_this.props.valueKey];
      }

      return item[_this.props.displayKey];
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getItemFromValue", function (value) {
      if (!_this.props.valueKey) {
        return value;
      }

      return _this.props.options.filter(function (item) {
        return typeof item === 'string' ? item === value : // eslint-disable-next-line eqeqeq
        item[_this.props.valueKey] == value;
      })[0];
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getValueFromItem", function (item) {
      if (typeof item === 'string') {
        return item;
      }

      if (!_this.props.valueKey) {
        return item;
      }

      return item[_this.props.valueKey];
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "selectItem", function (value) {
      _this.props.onChange && _this.props.onChange(value);

      if (!_this.props.inForm) {
        _this.setState({
          value: value
        }, _this.getPosition);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setFocus", function (index) {
      _this.setState({
        focus: index
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "moveFocus", function (offset) {
      var nextFocusIndex = _this.state.focus + offset;

      if (nextFocusIndex < 0) {
        nextFocusIndex = _this.props.options.length - 1;
      } else if (nextFocusIndex >= _this.props.options.length) {
        nextFocusIndex = 0;
      }

      _this.setFocus(nextFocusIndex);
    });
    _this.state = {
      value: _props.defaultValue && _props.defaultValue.toString() || null,
      open: false,
      focus: -1
    };
    return _this;
  }

  var _proto = DropDownComponent.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.getPosition();
    window.addEventListener('scroll', this.getPosition);
    window.addEventListener('resize', this.getPosition);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('scroll', this.getPosition);
    window.removeEventListener('resize', this.getPosition);
  };

  _proto.getValue = function getValue() {
    var _this$props = this.props,
        inForm = _this$props.inForm,
        defaultValue = _this$props.defaultValue,
        value = _this$props.value,
        fieldValue = _this$props.fieldValue;

    if (inForm) {
      return fieldValue != null ? fieldValue : defaultValue || null;
    }

    if (value != null) {
      return value || defaultValue || null;
    }

    return this.state.value;
  };

  _proto.render = function render() {
    var _this2 = this;

    var muitheme = this.getDropDownTheme(this.props, this.context);
    var value = this.getValue();
    var showError = (this.props.isSubmitted() || this.props.dirty) && !!this.props.errorMessage;
    return _react.default.createElement(OutterContainer, {
      muitheme: muitheme,
      onKeyDown: this.handleInputKeyDown
    }, _react.default.createElement("div", {
      ref: this.containerRef
    }, _react.default.createElement(Container, null, _react.default.createElement(Touchable, {
      isopen: this.state.open,
      disabled: this.props.disabled,
      onPress: this.onPress
    }, _react.default.createElement(InnerContainer, {
      muitheme: muitheme,
      disabled: this.props.disabled
    }, _react.default.createElement(Label, {
      disabled: this.props.disabled,
      muitheme: muitheme
    }, value != null ? this.printValue(value) : this.props.label), !this.props.disabled && _react.default.createElement(IconContainer, {
      muitheme: muitheme
    }, _react.default.createElement(SvgArrowDown, null)))), _react.default.createElement(ErrorMessage, {
      muitheme: muitheme
    }, showError ? this.props.errorMessage : ''))), this.state.open && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactOverlays.Modal, {
      className: _zIndexClass.default,
      show: true,
      style: BACKSTYLE
    }, _react.default.createElement("div", null, _react.default.createElement(Backdrop, {
      muitheme: muitheme,
      onPress: this.dismissMenu,
      onMouseOver: function onMouseOver() {
        return _this2.setFocus(-1);
      }
    }), _react.default.createElement(DropMenu, {
      muitheme: muitheme,
      position: this.state.containerPos,
      width: this.state.containerWidth
    }, _react.default.createElement(ScrollView, null, this.props.options.map(function (item, index) {
      var itemValue = _this2.getValueFromItem(item);

      return _react.default.createElement(DropItem, {
        muitheme: muitheme,
        onMouseOver: function onMouseOver() {
          return _this2.setFocus(index);
        },
        onFocus: function onFocus() {
          return _this2.setFocus(index);
        },
        onPress: function onPress() {
          return _this2.closeMenu();
        },
        key: "item-" + index
      }, _react.default.createElement(ItemText, {
        muitheme: muitheme,
        withfocus: (_this2.state.focus === index).toString() // $FlowFixMe
        ,
        selected: value == itemValue
      }, _this2.printItem(item)));
    })))))));
  };

  return DropDownComponent;
}(_react.Component);

exports.DropDownComponent = DropDownComponent;
(0, _defineProperty2.default)(DropDownComponent, "contextType", _ThemeProvider.default);

var _default = (0, _forms.turnIntoField)(DropDownComponent);

exports.default = _default;